import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import { formDataPost } from "../helpers/Helpers";
import withForm from '../layouts/withForm';
const SecuritySaltChange = ({handleChange}) => {
    const {
        settingData, 
    } = useMenu();
    
    const [options, setOptions] = useState(settingData?.security?.['salt_change'])
    const [saltChanging, setSaltChanging] = useState(false)
    const [saltChanged, setSaltChanged] = useState(false)
    const [saltError, setSaltError] = useState(null)
    

    const handleSaltReset = async () => {
        const confirmation = window.confirm(__( "Are you sure you want to proceed?", "ultimate-security" ));
        let result;
        if (confirmation) {            
            setSaltChanging(true);
            setSaltError(null);            
            try {
                result = await formDataPost('ultimate_security_update_wp_config_keys', {});
                if (result.success) {
                    setSaltChanged(true);
                    setTimeout(() => {
                        setSaltChanged(false);
                        window.location.reload();
                    }, 3000);
                }
            } catch (error) {
                setSaltError(error.message);
                setSaltChanging(false);
            } finally {
                setSaltChanging(false);
            }
            
        }
    }

    const [saltKeys, setSaltKeys] = useState(null);
    useEffect(() => {
        const fetchSaltKeys = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-salt",
                    method: "GET"
                });
				
               
                // Update state
                setSaltKeys(results);
            } catch (error) {
                console.error("Error fetching salt keys:", error);
            }
        };
        
		fetchSaltKeys();
    }, []);

    return (
        <>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("AUTH_KEY", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.AUTH_KEY}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("SECURE_AUTH_KEY", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.SECURE_AUTH_KEY}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("LOGGED_IN_KEY", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.LOGGED_IN_KEY}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("NONCE_KEY", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.NONCE_KEY}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("AUTH_SALT", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.AUTH_SALT}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("SECURE_AUTH_SALT", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.SECURE_AUTH_SALT}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("LOGGED_IN_SALT", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.LOGGED_IN_SALT}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("NONCE_SALT", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{saltKeys?.NONCE_SALT}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <InfoBox className="big-infobox" title={__("NOTE", "ultimate-security")} content={__("Changing WordPress salt keys will force all logged-in users to login again.", "ultimate-security")} />
            </div>
            {ultimate_security_ajax_obj.isPro && 
            <>
                <div className="setting-unit pb-lg mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Scheduled Change:", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Choose when WordPress salt keys should be changed automatically:", "ultimate-security")}</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint position="top" content={__("Set an scheduled duration to change your Salt Keys automatically", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Change WordPress salt keys", "ultimate-security")}</h6>
                                    </div>
                                    <div className="content-below-with-hint mt-2">    
                                        <select 
                                            className="form-select"
                                            value={settingData?.security?.['salt_change']?.schedule_type} 
                                            onChange={(e) => handleChange('security.salt_change.schedule_type', e.target.value)}
                                        >
                                            <option value="daily">{__( "Daily", "ultimate-security" )}</option>
                                            <option value="weekly">{__( "Weekly", "ultimate-security" )}</option>
                                            <option value="monthly">{__( "Monthly", "ultimate-security" )}</option>
                                            <option value="quarterly">{__( "Quarterly", "ultimate-security" )}</option>
                                            <option value="biannually">{__( "Biannually", "ultimate-security" )}</option>
                                            <option value="manual">{__( "Set Manual Time", "ultimate-security" )}</option>
                                        </select>     
                                    </div>
                                </div>
                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.salt_change.enable_schedules"
                                        checked={settingData?.security?.['salt_change']?.enable_schedules} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`setting-unit pb-lg mb-lg ${settingData?.security?.['salt_change']?.schedule_type!='manual' ? 'deactive-section' : ''}`}>
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Set Manual Time", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Choose a manual duration for changing your WordPress salt keys automatically:", "ultimate-security")}</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint position="top" content={__("Set a manual time from the day and time picker", "ultimate-security")}/>
                                        <div className="d-flex align-items-center gap-2 w-375">
                                            <select 
                                                className="form-select" 
                                                value={settingData?.security?.['salt_change']?.schedule_day}
                                                onChange={(e)=> handleChange('security.salt_change.schedule_day', e.target.value)}
                                                disabled={settingData?.security?.['salt_change']?.schedule_type!='manual'}
                                            >
                                                <option value="saturday">{__( "Saturday", "ultimate-security" )}</option>
                                                <option value="sunday">{__( "Sunday", "ultimate-security" )}</option>
                                                <option value="monday">{__( "Monday", "ultimate-security" )}</option>
                                                <option value="tuesday">{__( "Tuesday", "ultimate-security" )}</option>
                                                <option value="wednesday">{__( "Wednesday", "ultimate-security" )}</option>
                                                <option value="thursday">{__( "Thursday", "ultimate-security" )}</option>
                                                <option value="friday">{__( "Friday", "ultimate-security" )}</option>
                                            </select>
                                            <span>{__( "at", "ultimate-security" )}</span>
                                            <input 
                                                type="time" 
                                                className="form-control" 
                                                onChange={(e)=> handleChange('security.salt_change.schedule_time', e.target.value)} 
                                                value={settingData?.security?.['salt_change']?.schedule_time}
                                                disabled={settingData?.security?.['salt_change']?.schedule_type!='manual'}
                                            />
                                        </div>
                                    </div>
                                    <div className="content-below-with-hint">                                    
                                        <InfoBox className="small-infobox mt-2" title={__( "Note", "ultimate-security" )} content={__( "This will be the time when the salt keys will be changed.", "ultimate-security" )} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit pb-lg mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Reminder for Changing Salt Keys", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Be in the loop after a certain period of time if you need to change your Salt Keys.", "ultimate-security")}</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint position="top" content={__("Enable reminder for changing salt keys", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Remind me to update the keys manually.", "ultimate-security")}</h6>
                                    </div>
                                </div>
                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.salt_change.schedule_reminder"
                                        checked={settingData?.security?.['salt_change']?.schedule_reminder} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit pb-lg mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Notification Before Change", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Get a simple notification for when your Salt keys are about to change.", "ultimate-security")}</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint position="top" content={__("Enable notifications before salt keys change", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Notify me when an automatic update takes place.", "ultimate-security")}</h6>
                                    </div>
                                </div>
                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.salt_change.schedule_notification"
                                        checked={settingData?.security?.['salt_change']?.schedule_notification} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }
            
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Immediate Change:", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("When you click the following button, WordPress salt keys will change immediately.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="d-flex align-items-center gap-2">     
                                    <button 
                                        type="button" 
                                        className="button button-secondary"
                                        onClick={handleSaltReset}
                                        disabled={saltChanging}
                                    >
                                        {saltChanging ? __( "Changing...", "ultimate-security" ) : __( "Change Now", "ultimate-security" )}                                                
                                    </button>
                                    {saltChanging && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {saltChanged && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}
export default withForm(SecuritySaltChange, 'security.salt_change');